import { render, staticRenderFns } from "./ProposalAuth.vue?vue&type=template&id=42fe26c8&"
import script from "./ProposalAuth.vue?vue&type=script&lang=js&"
export * from "./ProposalAuth.vue?vue&type=script&lang=js&"
import style0 from "./ProposalAuth.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports